var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staffs-license-assign" },
    [
      _c("licences", {
        attrs: {
          licenses: _vm.licenses,
          versionedLicenses: _vm.versionedLicenses
        }
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-4" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Attribution des licences")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "m-0 fs-3 lh-big",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t.__(
              "sellsyaccountmanager.SubscriptionManager.Staffs.licence_count_on_account",
              _vm.total
            )
          )
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "grey m-0 fs-3 lh-big" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Attribuez les en fonction des besoins de vos collaborateurs afin qu’ils puissent utiliser les différents modules proposés dans Sellsy."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-row br staff-form-container fs-3 p-2 mt-3 gray-0-bkg"
        },
        [
          _c("span", { staticClass: "semibold mr-3" }, [
            _vm._v(
              _vm._s(_vm.$l10n.__("%s collaborateurs au total", _vm.totalUser))
            )
          ]),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__(
                "sellsyaccountmanager.SubscriptionManager.Staffs.add_staff"
              ),
              type: "primary"
            },
            on: { click: _vm.openPopup }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.staffs } },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.name") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("avatar-randomized", {
                      attrs: {
                        firstname: scope.row.firstname,
                        lastname: scope.row.lastname,
                        avatarImage: scope.row.avatar
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-2 semibold" }, [
                      _vm._v(
                        _vm._s(scope.row.firstname + " " + scope.row.lastname)
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "sellsyaccountmanager.SubscriptionManager.Staffs.job_title"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "darkgrey" }, [
                      _vm._v(_vm._s(scope.row.position))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: 224,
              label: _vm.$t.__("common.labels.licence_type")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.loading
                      ? _c("select-loader", {
                          attrs: {
                            message: _vm.$t.__(
                              "common.labels.allocation_in_progress"
                            )
                          }
                        })
                      : _c(
                          "el-select",
                          {
                            staticClass: "w-2",
                            attrs: { value: scope.row.license },
                            on: {
                              change: function($event) {
                                return _vm.updateLicense($event, scope.row)
                              }
                            }
                          },
                          _vm._l(_vm.availableLicenses, function(license) {
                            return _c("el-option", {
                              key: license.value,
                              attrs: {
                                disabled: license.disabled,
                                label: license.label,
                                value: license.value
                              }
                            })
                          }),
                          1
                        )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("template", { slot: "empty" }, [
            _c(
              "div",
              { staticClass: "staffs-license-assign__no-result" },
              [
                _c("CompassEmptyState", {
                  attrs: {
                    illustrationPath:
                      "/ressources/logged/img/illustrations/no-results.svg",
                    caption: _vm.labels.empty
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              attrs: { slot: "append" },
              on: { infinite: _vm.infiniteHandler },
              slot: "append"
            },
            [
              _c(
                "div",
                {
                  staticClass: "py-2",
                  attrs: { slot: "spinner" },
                  slot: "spinner"
                },
                [_vm._v(_vm._s(_vm.$l10n.__("Chargement en cours...")))]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" })
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }